import { render, staticRenderFns } from "./WordTemplatesList.vue?vue&type=template&id=41467114&"
import script from "./WordTemplatesList.vue?vue&type=script&lang=js&"
export * from "./WordTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./WordTemplatesList.vue?vue&type=style&index=0&id=41467114&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports